import { createComponent } from '@carvana/merch-components';

export const DynamicPromoCard = createComponent('div', {
  className:
    'flex w-full min-w-[327px] flex-1 flex-col justify-between gap-24 overflow-hidden rounded-[8px] border border-grey-2 bg-white p-24 m:p-32 '
});

export const NewUserPromoCard = createComponent(DynamicPromoCard, {
  className: '!flex-row !gap-16 p-8 pr-16 m:!hidden'
});

export const Image = createComponent('img', {
  className: 'h-[160px] w-full rounded-md object-cover m:h-[204px]'
});

export const Header = createComponent('header', {
  className: 'flex flex-col gap-8'
});

export const Title = createComponent('span', {
  className: 'text-xl font-semibold text-blue-6 m:text-[28px] m:leading-8'
});

export const SubTitle = createComponent('span', {
  className: 'text-sm text-grey-5 m:text-lg'
});

export const MainContentWrapper = createComponent('section', {
  className:
    'flex w-full flex-1 flex-col gap-16 overflow-hidden rounded-md border border-grey-2 p-24'
});

export const MainContentHeader = createComponent('span', {
  className: 'flex flex-col gap-8'
});

export const StatusPill = createComponent('span', {
  className:
    'inline-flex h-[24px] w-fit items-center rounded-lg px-8 align-middle text-xs'
});

export const MainContentBoldText = createComponent('span', {
  className: 'text-base font-semibold text-blue-6'
});
